const isChildType = (child, component) => {
	try {
		if (component?.displayName && child?.type?.displayName) {
			return component.displayName === child.type.displayName;
		}
	} catch {
		console.error("Unable to match React children type");
	}

	return false;
};

export default isChildType;
export { isChildType };
